import { render, staticRenderFns } from "./UserAppeal.vue?vue&type=template&id=546c1116&scoped=true&"
import script from "./UserAppeal.vue?vue&type=script&lang=js&"
export * from "./UserAppeal.vue?vue&type=script&lang=js&"
import style0 from "./UserAppeal.vue?vue&type=style&index=0&id=546c1116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c1116",
  null
  
)

export default component.exports